import Pagination from '@material-ui/lab/Pagination';
import { Form, Input, Select, message } from 'antd';
import _ from 'lodash';
import moment from "moment";
import React, { Suspense, useEffect, useState } from "react";
import { injectIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory, withRouter } from "react-router-dom";
import CustomButton from '../../../components/CustomButton';
import { actionDeleteExpertCMS, actionGetListExpertCMS } from '../../../redux/post/actions';
import { useSubheader } from "../../../_metronic/layout";
import {
    Card,
    CardBody,
    CardHeader
} from "../../../_metronic/_partials/controls";
import CreateUpdateExpert from './CreateUpdateExpert';
import ActionEditDelete from '../../../components/ActionEditDelete';
import { CaretDownOutlined } from '@ant-design/icons';

const formRef = React.createRef()

function ListExpert(props) {
    const suhbeader = useSubheader();
    const history = useHistory()
    const [visibleSearch, setVisibleSearch] = useState(false)
    const [visibleModal, setVisibleModal] = useState(false)
    const [recordModal, setRecordModal] = useState(null)
    const [filterModal, setFilterModal] = useState(null)
    const { intl } = props
    suhbeader.setTitle(intl.formatMessage({ id: 'SIDEBAR.EXPERT' }));
    const dispatch = useDispatch();
    const { dataExpertCMS } = useSelector(state =>
    ({  
        dataExpertCMS: state.postReducer.dataExpertCMS,
    })
        , shallowEqual)

    useEffect(() => {
        dispatch(actionGetListExpertCMS({ page: 1, limit: 15 }));
    }, [dispatch])

    const onChangePage = async (_, page) => {
        let { fullname } = formRef.current.getFieldsValue()
        await dispatch(actionGetListExpertCMS({ page, fullname: fullname ? fullname.trim() : '' }));
    }

    const onSearchDelayed = _.debounce(() => onSearch(), 100)
    const onSearch = async () => {
        let { fullname, gender, status, department } = formRef.current.getFieldsValue()
        setVisibleSearch(true)
        await dispatch(actionGetListExpertCMS({ page: 1, limit: 15, fullname: fullname ? fullname.trim() : '', gender: gender, status: status, department: department }));
    }

    const onDelete = async (id) => {
        if (window.confirm("Bạn có muốn xóa?")) {
            const res = await dispatch(actionDeleteExpertCMS({
                id,
                filterModal: {
                    page: dataExpertCMS?.paging?.page,
                    limit: 15,
                }
            }));
            if (res) {
                message.success("Xóa thành công")
            }
        }
    }

    const enterKeyPressed = (event) => {
        if (event.keyCode === 13) {
            onSearch()
        }
    }

    const renderGender =(gender) => {
        switch (gender) {
            case 1:
                return 'Nam'
            case 2:
                return 'Nữ'
            default:
                return ''
        }
    }

    const renderDepartment =(department) => {
        switch (department) {
            case 1:
                return 'Nhân sự chủ chốt'
            case 2:
                return 'Ban kiểm soát'
            case 3:
                return 'Ban giám đốc'
            case 4:
                return 'Hội đồng quản trị'
        default:
            return ''
        }
    }

    const renderStatus = (status) => {
        switch (status) {
            case 1:
                return 'Hoạt động'       
            default:
                return 'Không hoạt động'
        }
    }

    const renderBodyTable = () => {
        return dataExpertCMS?.rows?.length > 0
            ? dataExpertCMS.rows.map((it, idx) => {
                return (
                    <tr key={`renderBodyTable_${it.id || idx}`}>
                        <td className="tr-center">
                            {(dataExpertCMS?.paging?.page - 1) * dataExpertCMS?.paging?.limit + idx + 1}
                        </td>
                        <td className="tr-left">
                            {it?.fullname || "--"}
                        </td>
                        <td className="tr-left maxw--100">
                            {renderGender(it?.gender) || ""}
                        </td>
                        {/* <td className="tr-left maxw--100">
                            {it?.position || ""}
                        </td> */}
                        <td className="tr-left maxw--100">
                            {renderDepartment(it?.department) || ""}
                        </td>
                        {/* <td className="tr-left">
                            {
                                it.degree.map((e, i)=>{
                                    return (
                                        <>
                                            {e.title !== '' && <p>{`${e.title} - ${e.description}`} </p>}
                                        </>
                                    )
                                })
                            } 
                        </td>
                        <td className="tr-left">
                            {
                                it.experience.map((e, i)=>{
                                    return (
                                        <>
                                            {e.title !== '' && <p>{`${e.title} - ${e.description}`} </p>}
                                        </>
                                    )
                                })
                            } 
                        </td>
                        <td className="tr-left">
                            {it?.description ? `${it?.description.slice(0, 100)}...` : '--' || "--"}
                        </td> */}
                        <td className="tr-center">
                            {moment(it?.createdAt).format('DD/MM/YYYY') || "--"}
                        </td>
                        <td className="tr-center">
                            {renderStatus(it?.status)}
                        </td>
                        <td className="tr-center">
                            <ActionEditDelete
                                tooltipText=""
                                onclickEdit={() => onOpenModal(it)}
                                // onclickPreviewView={() => onclickPreviewView(it)}
                                onclickDelete={() => onDelete(it.id)}
                                hideView={true}
                            />
                        </td>
                    </tr>
                )
            })
            : <tr>
                <td className="tr-center" colSpan={12}>Không có dữ liệu hiển thị</td>
            </tr>
    }

    const onCloseModal = () => {
        setRecordModal(null)
        setFilterModal(null)
        setVisibleModal(false)
    }

    const onOpenModal = (dataEdit) => {
        console.log(dataEdit?.id, 'dataEdit.id=============================');
        if (!dataEdit)
            history.push("/expert/0");
        else
            history.push(`/expert/${dataEdit.id}`);
    }

    // const onOpenModal = (dataEdit) => {
    //     if (!dataEdit)
    //         setRecordModal(null)
    //     else
    //         setRecordModal(dataEdit)

    //     setFilterModal({
    //         page: dataExpertCMS?.paging?.page
    //     })
    //     setVisibleModal(true)
    // }

    const onClearSearch = async () => {
        formRef.current.setFieldsValue({ fullname: undefined, gender: '', department: '', status: '' })
        setVisibleSearch(false)
        await dispatch(actionGetListExpertCMS({ page: 1, limit: 15 }));
    }

    return (
        <>
            <Card>
                <CardHeader title={intl.formatMessage({ id: 'SIDEBAR.EXPERT' })}>
                </CardHeader>
                <CardBody>
                    <Form
                        className="width100"
                        ref={formRef}
                    >
                        <div className="layout-form-header row">
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">
                                    Tên chuyên gia{` `}
                                </div>
                                <Form.Item
                                    className="name"
                                    name="fullname"
                                >
                                    <Input
                                        onKeyDown={enterKeyPressed}
                                        className="customInput width100"
                                        placeholder="Nhập tên tác giả"
                                    />
                                </Form.Item>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">Giới tính{` `}</div>
                                <Form.Item
                                    name="gender"
                                >
                                    <Select
                                        className="customSelect"
                                        suffixIcon={<CaretDownOutlined />}
                                        onChange={()=>onSearchDelayed()}
                                        placeholder={"Chọn giới tính"}
                                        defaultValue={''}
                                    >   
                                        <Select.Option value={''}>Tất cả</Select.Option>
                                        <Select.Option value={1}>Nam</Select.Option>
                                        <Select.Option value={2}>Nữ</Select.Option>
                                    </Select>
                                </Form.Item>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">Ban ngành{` `}</div>
                                <Form.Item
                                    name="department"
                                >
                                    <Select
                                        className="customSelect"
                                        suffixIcon={<CaretDownOutlined />}
                                        onChange={()=>onSearchDelayed()}
                                        placeholder={"Chọn ban ngành"}
                                        defaultValue={''}
                                    >   
                                        <Select.Option value={''}>Tất cả</Select.Option>
                                        <Select.Option value={1}>Nhân sự chủ chốt</Select.Option>
                                        <Select.Option value={2}>Ban kiểm soát</Select.Option>
                                        <Select.Option value={3}>Ban giám đốc</Select.Option>
                                        <Select.Option value={4}>Hội đồng quản trị</Select.Option>
                                    </Select>
                                </Form.Item>
                            </div>
                            <div className="col-sm-3 mb--16">
                                <div className="customLabel">Trạng thái{` `}</div>
                                <Form.Item
                                    name="status"
                                >
                                    <Select
                                        className="customSelect"
                                        suffixIcon={<CaretDownOutlined />}
                                        onChange={()=>onSearchDelayed()}
                                        placeholder={"Chọn trạng thái"}
                                        defaultValue={''}
                                    >   
                                        <Select.Option value={''}>Tất cả</Select.Option>
                                        <Select.Option value={1}>Hoạt động</Select.Option>
                                        <Select.Option value={0}>Không hoạt động</Select.Option>
                                    </Select>
                                </Form.Item>
                            </div>
                        </div>
                        <div className="mb--20 row-end">
                            <CustomButton
                                className="mr--10"
                                title="Tìm kiếm"
                                btnBgColor="#3699ff"
                                btnColor="#ffffff"
                                btnHoverBackground="#187de4"
                                onClick={onSearchDelayed}
                            />
                            {visibleSearch && <CustomButton
                                className="customClearSearch mr--10"
                                title="Bỏ lọc"
                                btnBgColor="#eceef7"
                                btnColor="#192038"
                                btnHoverBackground="#eceef7"
                                onClick={onClearSearch}
                            />}
                            <CustomButton
                                title="Thêm mới"
                                btnBgColor="#3699ff"
                                btnColor="#ffffff"
                                btnHoverBackground="#187de4"
                                onClick={onOpenModal}
                            />

                        </div>
                        <div className="trongCustomTableCtn2">
                            <table className="customTable">
                                <tr className="bg-E6F8FD">
                                    <th className="tr-center">STT</th>
                                    <th className="tr-center">Tên tác giả</th>
                                    <th className="tr-center max--100">Giới tính</th>
                                    {/* <th className="tr-center">Vị trí/ chức vụ</th> */}
                                    <th className="tr-center">Ban ngành</th>
                                    {/* <th className="tr-center max--100">Bằng cấp</th>
                                    <th className="tr-center max--100">Kinh nghiệm</th>
                                    <th className="tr-center">Thông tin tác giả</th> */}
                                    <th className="tr-center">Ngày tạo</th>
                                    <th className="tr-center">Trạng thái</th>
                                    <th className="tr-center">Thao tác</th>
                                </tr>
                                {renderBodyTable()}
                            </table>
                        </div>
                        <div className="mt--20 rowx-center">
                            {dataExpertCMS?.paging?.total > dataExpertCMS?.paging?.limit && <div className="mt--20 rowx-center">
                                <Pagination
                                    count={dataExpertCMS?.paging?.count} //total
                                    page={dataExpertCMS?.paging?.page} //current page
                                    variant="outlined" shape="rounded" showFirstButton showLastButton
                                    onChange={(event, page) => onChangePage(event, page)}
                                />
                            </div>}
                        </div>
                    </Form>
                </CardBody>
            </Card>
            <Suspense fallback={<div></div>}>
                <section>
                    {visibleModal && <CreateUpdateExpert
                        onCloseModal={onCloseModal}
                        visibleModal={visibleModal}
                        recordModal={recordModal}
                        filterModal={filterModal}
                    />}
                </section>
            </Suspense>
        </>
    );
};
export default injectIntl(withRouter(ListExpert));